module.exports = __webpack_public_path__ + "static/media/testSuccess.6b008579.png";